// Material UI
import { makeStyles } from '@material-ui/styles'
// Consts
import Colors from '../../../constants/Colors'

export default makeStyles(theme => ({
  root: {
    margin: '24px 0px',
    backgroundColor: Colors.WHITE,
  },
  header: {
    color: Colors.PRIMARY_FONT_COLOR,
    fontSize: 17,
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'normal',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    padding: '16px',
    [theme.breakpoints.up('md')]: {
      padding: '24px',
    },
  },
  content: {
    fontSize: '15px',
    borderTop: `1px solid ${Colors.DISABLED_COLOR}`,
    padding: '24px 16px',
    [theme.breakpoints.up('md')]: {
      padding: '24px',
    },
  },
}))
